import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';



export const StatusTag = ({ 
  status, 
  size = 'sm', 
  animate = false 
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'healthy':
        return {
          icon: CheckCircle,
          text: 'Healthy',
          bgColor: 'bg-green-100 border-green-200',
          textColor: 'text-green-800',
          iconColor: 'text-green-600'
        };
      case 'warning':
        return {
          icon: AlertTriangle,
          text: 'Warning',
          bgColor: 'bg-amber-100 border-amber-200',
          textColor: 'text-amber-800',
          iconColor: 'text-amber-600'
        };
      case 'critical':
        return {
          icon: XCircle,
          text: 'Critical',
          bgColor: 'bg-red-100 border-red-200',
          textColor: 'text-red-800',
          iconColor: 'text-red-600'
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const pulseClass = animate && status === 'critical' ? 'animate-pulse' : '';

  return (
    <div className={`
      inline-flex items-center gap-1.5 rounded-full border font-medium
      ${config.bgColor} ${config.textColor} ${sizeClasses[size]} ${pulseClass}
      transition-all duration-200 hover:shadow-sm
    `}>
      <Icon className={`${iconSizes[size]} ${config.iconColor}`} />
      <span>{config.text}</span>
    </div>
  );
};